module.exports = __webpack_public_path__ + "images/switch-on-399b94b9.svg";